/**
 * @author NikolaV
 */
import { DocumentPropertiesList } from '@pages/map/actions/DocumentPropertiesList';
import { DocumentsImagesPanelThumbnails } from '@shared/documents-images/ui/DocumentsImagesPanelThumbnails';
import { DocumentInfoPanel, DocxViewer, PdfOrExternalViewer } from '@shared/documents/ui/DocumentViewers';
import { Events } from '@shared/Events';
import { TreeNode } from '@shared/ui-native/Tree';
import { Button } from '@shared/ui-react/Button';
import { cs } from '@shared/utils/utils-classname';
import * as React from 'react';
import './DocumentViewerWithNavigation.scss';


export class DocumentViewerWithNavigation extends React.Component<{
    initialId: number,
    queue: IDocument[],
    onEdit: (item: IDocument) => void,
    onOpen: (itemId: number) => void,
    folderTreeNode: TreeNode,
    onOpenFolderId: (folderId: number, documentId: number) => void
    onCenter: (item: IDocument) => void
}, {
    currentIndex: number,
    showQueueThumbnails?: boolean
}> {

    state = {
        currentIndex: this.props.initialId ? this.props.queue.findIndex(i => i.id === this.props.initialId) : 0,
        showQueueThumbnails: false,
    }

    componentWillUnmount() {
        Events.trigger('map-highlight-clear');
    }

    goNext = () => this.setState(prevState => ({
        currentIndex: (prevState.currentIndex + 1) % this.props.queue.length,
        showQueueThumbnails: false
    }));

    goPrev = () => this.setState(prevState => ({
        currentIndex: (prevState.currentIndex - 1 + this.props.queue.length) % this.props.queue.length,
        showQueueThumbnails: false
    }));

    goFirst = () => this.setState({ currentIndex: 0, showQueueThumbnails: false });

    goLast = () => this.setState({ currentIndex: this.props.queue.length - 1, showQueueThumbnails: false });

    setIndexById = (imageId: number) => {
        const index = this.props.queue.findIndex(i => i.id === imageId);
        this.setState({ currentIndex: index, showQueueThumbnails: false });
    }

    toggleQueueThumbnails = () => {
        this.setState({ showQueueThumbnails: !this.state.showQueueThumbnails });
    }

    render() {
        const { queue, onEdit } = this.props;

        if (!queue.length) {
            return <div>Cant find the document</div>;
        }

        const index = this.state.currentIndex;
        const idocument = queue[index];
        const total = queue.length;
        const ext = utils.getExtensionFromFilename(idocument.name);
        const canEdit = kuura.hasPrivilege('PROJECT_W');
        const canDownload = kuura.hasPrivilege('Download_Model');
        const hasLocation = idocument.geographicPoint?.lon && idocument.geographicPoint?.lon !== 0;

        return (
            <>
                <div className='floating-window-toolbar document-popup-toolbar'>
                    {total > 1 && <>
                        <div id='document-popup-prev' className={cs('toolbar-btn')} onClick={this.goPrev}><i className='iki iki-chevron-left'></i></div>
                        <div id='document-popup-next' className={cs('toolbar-btn')} onClick={this.goNext}><i className='iki iki-chevron-right'></i></div>
                    </>}
                    <div className='doc-popup-counts flex-row ai-center clickable' onClick={this.toggleQueueThumbnails}>{index + 1} / {total} {queue.length > 1 && <i style={{ marginLeft: 10 }} className="iki iki-grid" title='Showing images at selected location, cluster  or folder' />}</div>

                    {canEdit ? <Button element='div' tooltip={__('general.edit')} icon='iki iki-edit' className='toolbar-btn' id='image-popup-edit' onClick={() => this.props.onEdit(idocument)} /> : null}
                    {hasLocation ? <Button element='div' tooltip={__('general.locate_on_map')} icon='iki iki-map-pin' className='toolbar-btn' id='image-popup-center' onClick={() => this.props.onCenter(idocument)} /> : null}
                    {(canDownload && !idocument.url) && <Button element='div' tooltip={__('general.download')} icon='iki iki-download' className='toolbar-btn' onClick={() => window.open(kuura.getContextPath() + '/api/1/file/' + idocument.id + '/get?inline=true')} />}
                </div>

                {this.state.showQueueThumbnails && <div className='flex-column of-h'>
                    <DocumentsImagesPanelThumbnails
                        type='documents'
                        items={queue}
                        unfilteredItems={queue}
                        canEdit={false}
                        canSelect={false}
                        canDownload={false}
                        focusItemId={idocument.id}
                        onClick={this.setIndexById}
                    />
                </div>}

                {(ext === 'pdf' || ext === 'txt' || idocument.url) && <PdfOrExternalViewer hidden={this.state.showQueueThumbnails} idocument={idocument} infoPosition={null} />}
                {ext === 'docx' && <div className='of-a' style={{ display: this.state.showQueueThumbnails ? 'none' : 'flex', flexGrow: 1 }}><DocxViewer document={idocument} /></div>}

                <div style={{ display: this.state.showQueueThumbnails ? 'none' : 'initial', overflow: 'auto', flexShrink: 0, maxHeight: 150, minHeight: 50 }}>
                    <DocumentInfoPanel idocument={idocument} folderTreeNode={this.props.folderTreeNode} goToFolder={id => this.props.onOpenFolderId(id, idocument.id)} />

                    {!idocument.url && <div style={{ textAlign: 'left', margin: '0 0 5px 15px' }}>
                        <DocumentPropertiesList doc={idocument} canEdit={canEdit} />
                    </div>}
                </div>
            </>
        );
    }
}

